import { Component, Fragment } from 'react';
import { postData, putData, getData } from "../../servicos/api";
import { isAdmin } from "../../servicos/auth";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { Form, FormGroup, Label, Input, Button, Card, CardHeader, CardBody, CardFooter } from 'reactstrap';
import Navbar from '../../Components/Navbar';
import Sidebar from '../../Components/Sidebar';
import ModalResponse from '../../Components/ModalResponse';
import Combobox from '../../Components/Combobox';
import { Link } from "react-router-dom";
import Switch from 'react-switch';

//REDUX
import { setLoaderShow, setResponseModal } from '../../reducers/index';
import { connect } from 'react-redux';

const Formulario = (props) => {let estabelecimento;
    if (props.data && props.data.estabelecimento_id !== undefined && props.data.estabelecimento_id !== null && props.listaEstabelecimentos.length > 0) {
        estabelecimento = props.listaEstabelecimentos.filter(function (elem, i, object) {
            return elem.value === props.data.estabelecimento_id;
        });
        if(estabelecimento[0] !== undefined){
            estabelecimento = { value: estabelecimento[0].value, label: estabelecimento[0].label };
        }
    }
    
    let estado;
    if (props.data && props.data.estado_id !== undefined && props.data.estado_id !== null && props.listaEstados.length > 0) {
        estado = props.listaEstados.filter(function (elem, i, object) {
            return elem.value === props.data.estado_id;
        });
        if(estado[0] !== undefined){
            estado = { value: estado[0].value, label: estado[0].label };
        }
    }

    let cidade;
    if (props.data && props.data.cidade_id !== undefined && props.data.cidade_id !== null && props.listaCidades.length > 0) {
        cidade = props.listaCidades.filter(function (elem, i, object) {
            return elem.value === props.data.cidade_id;
        });
        if(cidade[0] !== undefined){
            cidade = { value: cidade[0].value, label: cidade[0].label };
        }
    }

    let bairro;
    if (props.data && props.data.bairro_id !== undefined && props.data.bairro_id !== null && props.listaBairros.length > 0) {
        bairro = props.listaBairros.filter(function (elem, i, object) {
            return elem.value === props.data.bairro_id;
        });
        if(bairro[0] !== undefined){
            bairro = { value: bairro[0].value, label: bairro[0].label };
        }
    }

    let validarAdmin = Yup.object({
        estado_id: Yup.object()
            .required('O campo estado é obrigatório.'),
        cidade_id: Yup.object()
            .required('O campo cidade é obrigatório.'),
        bairro_id: Yup.object()
            .required('O campo bairro é obrigatório.'),
        logradouro: Yup.string()
            .min(2, 'O campo rua deverá ter no mínimo 2 caracteres.')
            .max(200, 'O campo rua deverá ter no máximo 200 caracteres.')
            .required('O campo rua é obrigatório.')
            .trim(),
        cep: Yup.string()
            .nullable()
            .trim(),
        estabelecimento_id: Yup.object()
            .required('O campo estabelecimento é obrigatório.'),
    });

    let validarEstabelecimento = Yup.object({
        estado_id: Yup.object()
            .required('O campo estado é obrigatório.'),
        cidade_id: Yup.object()
            .required('O campo cidade é obrigatório.'),
        bairro_id: Yup.object()
            .required('O campo bairro é obrigatório.'),
        logradouro: Yup.string()
            .min(2, 'O campo rua deverá ter no mínimo 2 caracteres.')
            .max(200, 'O campo rua deverá ter no máximo 200 caracteres.')
            .required('O campo rua é obrigatório.')
            .trim(),
        cep: Yup.string()
            .nullable()
            .trim(),
    });

    const formik = useFormik({
        initialValues: {
            estado_id:          estado,
            cidade_id:          cidade,
            bairro_id:          bairro,
            logradouro:         props.data !== undefined && props.data !== null ? props.data.logradouro : '',
            cep:                props.data !== undefined && props.data !== null ? props.data.cep : '',
            ativo:              props.data !== undefined && props.data !== null ? !!parseInt(props.data.ativo) : true,
            estabelecimento_id: estabelecimento
        },
        enableReinitialize: true,
        validationSchema: isAdmin() ? validarAdmin : validarEstabelecimento,
        onSubmit: values => {
            let data = {
                "estado_id": values.estado_id.value,
                "cidade_id": values.cidade_id.value,
                "bairro_id": values.bairro_id.value,
                "logradouro" : values.logradouro,
                "cep" : values.cep,
                "ativo": values.ativo,
                "estabelecimento_id": values.estabelecimento_id || (isAdmin()) ? values.estabelecimento_id.value : null,
            }

            if (props.operation !== undefined && props.operation !== null && props.operation === 'alt') {
                props.updateEndereco(data, props.data.uuid);
            } else {
                props.insertEndereco(data);
            }
        },
    });
    return ( 
        <Form className="forms-sample col-12" onSubmit={formik.handleSubmit}>
            <Card>
                <CardHeader className="bg-maskats text-center">
                    <h4 className="headerTitle">Cadastro de endereços</h4>
                </CardHeader>
                <CardBody>
                    <div>

                        {
                            isAdmin() ? 
                                <FormGroup>
                                    <Label for="estabelecimento_id">* Estabelecimento</Label>
                                    <Combobox
                                        invalid={formik.touched.estabelecimento_id && formik.errors.estabelecimento_id}
                                        valid={formik.touched.estabelecimento_id && !formik.errors.estabelecimento_id}
                                        id="estabelecimento_id"
                                        name="estabelecimento_id"
                                        placeholder={'Selecione um item'}
                                        defaultValue={formik.values.estabelecimento_id}
                                        value={formik.values.estabelecimento_id}
                                        options={props.listaEstabelecimentos}
                                        isMulti={false}
                                        loadingMessage={"Carregando..."}
                                        noOptionsMessage={"Não existem dados cadastrados."}
                                        onChange={formik.setFieldValue}
                                        onBlur={formik.setFieldTouched}
                                        maxMenuHeight={190}
                                    />
                                    {formik.touched.estabelecimento_id && formik.errors.estabelecimento_id ? (
                                        <div className="divError">{formik.errors.estabelecimento_id}</div>
                                    ) : null}
                                </FormGroup>
                            : ""
                        }

                        <FormGroup>
                            <Label for="estado_id">* Estado</Label>
                            <Combobox
                                invalid={formik.touched.estado_id && formik.errors.estado_id}
                                valid={formik.touched.estado_id && !formik.errors.estado_id}
                                id="estado_id"
                                name="estado_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.estado_id}
                                value={formik.values.estado_id}
                                options={props.listaEstados}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.estado_id && formik.errors.estado_id ? (
                                <div className="divError">{formik.errors.estado_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="cidade_id">* Cidade</Label>
                            <Combobox
                                invalid={formik.touched.cidade_id && formik.errors.cidade_id}
                                valid={formik.touched.cidade_id && !formik.errors.cidade_id}
                                id="cidade_id"
                                name="cidade_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.cidade_id}
                                value={formik.values.cidade_id}
                                options={props.listaCidades}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.cidade_id && formik.errors.cidade_id ? (
                                <div className="divError">{formik.errors.cidade_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="bairro_id">* Bairro</Label>
                            <Combobox
                                invalid={formik.touched.bairro_id && formik.errors.bairro_id}
                                valid={formik.touched.bairro_id && !formik.errors.bairro_id}
                                id="bairro_id"
                                name="bairro_id"
                                placeholder={'Selecione um item'}
                                defaultValue={formik.values.bairro_id}
                                value={formik.values.bairro_id}
                                options={props.listaBairros}
                                isMulti={false}
                                loadingMessage={"Carregando..."}
                                noOptionsMessage={"Não existem dados cadastrados."}
                                onChange={formik.setFieldValue}
                                onBlur={formik.setFieldTouched}
                                maxMenuHeight={190}
                            />
                            {formik.touched.bairro_id && formik.errors.bairro_id ? (
                                <div className="divError">{formik.errors.bairro_id}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="logradouro">* Rua</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="logradouro" 
                                name="logradouro" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.logradouro}
                                minLength={2}
                                maxLength={200}
                            />
                            {formik.touched.logradouro && formik.errors.logradouro ? (
                                <div className="divError">{formik.errors.logradouro}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup>
                            <Label for="cep">CEP</Label>
                            <Input 
                                className="form-control form-control-sm" 
                                id="cep" 
                                name="cep" 
                                type="text" 
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.cep}
                            />
                            {formik.touched.cep && formik.errors.cep ? (
                                <div className="divError">{formik.errors.cep}</div>
                            ) : null}
                        </FormGroup>

                        <FormGroup className="mb-0">
                            <Label for="ativo">Ativo</Label>
                            <br />
                            <Switch
                                id="ativo"
                                name="ativo"
                                onColor="#28a745"
                                offColor="#dc3545"
                                checked={formik.values.ativo}
                                onChange={()=>formik.setFieldValue('ativo', !formik.values.ativo)}
                            />
                        </FormGroup>
                    </div>
                </CardBody>
                <CardFooter className="text-align-end bg-white">
                    <Link replace to="/endereco">
                        <Button className="mr-2 text-white btn btn-sm btn-secondary btn-fw bd-rd-8" type="button">
                            <i className="fa fa-arrow-left btn-icon-append btn-fs-def"></i>
                            <span className="label-button btn-fs-def">Cancelar</span>
                        </Button>
                    </Link>

                    <Button className="btn btn-sm btn-success btn-fw bd-rd-8" type="submit">
                        <i className="fa fa-check btn-icon-append btn-fs-def"></i>
                        <span className="label-button btn-fs-def">Salvar</span>
                    </Button>
                </CardFooter>
            </Card>
        </Form>
    );
}

class EnderecoFormulario extends Component {
    constructor(props){
        super(props);

        this.state = {
            listaEstabelecimentos: [],
            listaEstados: [],
            listaCidades: [],
            listaBairros: [],
        };
        
        this.loadingShow    = this.loadingShow.bind(this);
        this.updateEndereco = this.updateEndereco.bind(this);
        this.insertEndereco = this.insertEndereco.bind(this);
    }

    async componentDidMount(){
        this.loadingShow(true);

        let [listaEstabelecimentos, listaEstados, listaCidades, listaBairros] = await Promise.all([
            getData(`/estabelecimento`, this.props),
            getData(`/estado`, this.props),
            getData(`/cidade`, this.props),
            getData(`/bairro`, this.props)
        ]);

        if(listaEstabelecimentos !== null){
            listaEstabelecimentos = listaEstabelecimentos.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        if(listaEstados !== null){
            listaEstados = listaEstados.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        if(listaCidades !== null){
            listaCidades = listaCidades.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }
        
        if(listaBairros !== null){
            listaBairros = listaBairros.map(function (value) {
                return { value: value.id, label: value.nome, ativo: value.ativo };
            });
        }

        this.setState({listaEstados, listaCidades, listaBairros, listaEstabelecimentos});

        this.loadingShow(false);
    }

    loadingShow(value) {
        let { setLoaderShow } = this.props;
        setLoaderShow(value);
    }

    async updateEndereco(data, uuid){
        this.loadingShow(true);
        await putData(`/endereco/${uuid}`, this.props, data, '../endereco');
        this.loadingShow(false);
    }

    async insertEndereco(data){
        this.loadingShow(true);
        await postData(`/endereco`, this.props, data, '../endereco');
        this.loadingShow(false);
    }

    render(){
        const { data, operation } = this.props.location;
        const { setResponseModal, enableResponseModal } = this.props;
        return (
            <Fragment>
                <div className="container-scroller">
                    <Navbar/>
                    <div className="container-fluid page-body-wrapper">
                        <Sidebar/>
                        <div className="main-panel">
                            <div className="content-wrapper">
                                <div className="row">
                                    <div className="col-md-12 grid-margin stretch-card">
                                        <Formulario
                                            data={data}
                                            operation={operation}
                                            updateEndereco={this.updateEndereco}
                                            insertEndereco={this.insertEndereco}
                                            listaEstabelecimentos={this.state.listaEstabelecimentos}
                                            listaEstados={this.state.listaEstados}
                                            listaCidades={this.state.listaCidades}
                                            listaBairros={this.state.listaBairros}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalResponse 
                    history={this.props.history} 
                    setResponseModal={setResponseModal} 
                    enableResponseModal={enableResponseModal}
                />
            </Fragment>
        );
    }
}

const mapStateToProps = state => {
    return {
        enableLoaderShow: state.enableLoaderShow,
        enableResponseModal: state.enableResponseModal,
    }
};

const mapDispatchToProps = dispatch => ({
    setLoaderShow: enable => dispatch(setLoaderShow(enable)),
    setResponseModal: enable => dispatch(setResponseModal(enable)),
});

export default connect(mapStateToProps, mapDispatchToProps)(EnderecoFormulario);